import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';

import { TextField } from '../../../../../../components/Field/common';
import { trackNavigationToCard, trackOfferTeaserShow } from './tracking';
import { TitleField } from '../../../../../../components/Field/common/TitleField';
import { useOfferContext } from '../../../../../../utils/offerContext';
import { selectIds } from '../../../../../../selectors/ids';

export const TitleFieldContainer: React.FC = () => {
  const { id, title, url } = useOfferContext();
  const ids = useSelector(selectIds);

  const position = ids.findIndex(item => item === id);

  const handleClick = React.useCallback(() => {
    trackNavigationToCard({ id });
  }, [id]);

  const handleShow = React.useCallback(() => {
    trackOfferTeaserShow({ offerId: id, position });
  }, [id, position]);

  return (
    <TextField>
      <ActionAfterViewObserver
        percentVisible={0.5}
        callback={handleShow}
        triggerOnce
        callbackDelay={1000}
        trackVisibility
      >
        <TitleField url={url} onClick={handleClick}>
          {title}
        </TitleField>
      </ActionAfterViewObserver>
    </TextField>
  );
};
